import { theme } from "src/config";
import styled from 'styled-components' 

export const StickyTableCell = styled.td`
  position:     sticky;
  z-index:      10;
  left:         0;
  background:   ${theme.color.white};
  border-right: 1px solid ${theme.color.primaryBorder};
  
  :hover {
    background-color: ${theme.color.slate2};
  }
`